import i18next from 'i18next';

function toolTranslations(
  id: string,
  label: string,
  options?: { reasoning?: string; output?: string; noop?: string },
): Record<string, string> {
  return {
    [id]: label,
    [`${id}Reasoning`]: options?.reasoning ?? label,
    [`${id}Output`]: options?.output ?? `Completed: ${label}`,
    [`${id}Noop`]: options?.noop ?? `No results: ${label}`,
    [`${id}Error`]: `Error: ${label}`,
  };
}

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'ai-tool', {
    ...toolTranslations('readConvo', 'Read conversation', {
      reasoning: 'Reading conversation',
      output: 'Read conversation',
    }),
    ...toolTranslations('updateConvo', 'Update conversation', {
      reasoning: 'Updating conversation',
      output: 'Updated conversation',
    }),
    ...toolTranslations('trashConvo', 'Trash conversation', {
      reasoning: 'Trashing conversation',
      output: 'Trashed conversation',
    }),
    ...toolTranslations('findConvos', 'Find conversations', {
      reasoning: 'Finding conversations',
      output: 'Found {{count}} conversations',
      noop: 'No conversations found',
    }),
    ...toolTranslations('searchConvos', 'Search conversations', {
      reasoning: 'Searching conversations for {{toolCall.input.query}}',
      output: 'Found {{count}} conversations',
      noop: 'No conversations found',
    }),
    ...toolTranslations('abortConvo', 'Abort conversation', {
      reasoning: 'Aborting conversation',
      output: 'Aborted conversation',
    }),
    ...toolTranslations('readAgentConvo', 'Read agent conversation', {
      reasoning: 'Reading agent conversation',
      output: 'Read agent conversation',
    }),
    ...toolTranslations('updateAgentConvo', 'Update agent conversation', {
      reasoning: 'Updating agent conversation',
      output: 'Updated agent conversation',
    }),
    ...toolTranslations('trashAgentConvo', 'Trash agent conversation', {
      reasoning: 'Trashing agent conversation',
      output: 'Trashed agent conversation',
    }),
    ...toolTranslations('findAgentConvos', 'Find agent conversations', {
      reasoning: 'Finding agent conversations',
      output: 'Found {{count}} agent conversations',
      noop: 'No agent conversations found',
    }),
    ...toolTranslations('searchAgentConvos', 'Search agent conversations', {
      reasoning: 'Searching agent conversations for {{toolCall.input.query}}',
      output: 'Found {{count}} agent conversations',
      noop: 'No agent conversations found',
    }),
    ...toolTranslations('abortAgentConvo', 'Abort agent conversation', {
      reasoning: 'Aborting agent conversation',
      output: 'Aborted agent conversation',
    }),
  });
}
